export interface IQueryParameter {
    getParam(): string;
}
